/**
 * Encode target type for file service modified file upload.
 * Used when changing status to COMPLETED with a new file.
 */
export const ENCODE_TYPE_VALUES = [
  'int_flash',
  'ext_flash',
  'int_eeprom',
  'ext_eeprom',
  'maps',
  'full_dump',
] as const;

export type EncodeType = (typeof ENCODE_TYPE_VALUES)[number];
